<template>
    <div class="order-copy pop_white-s pop_bege popup_wrap" style="display:block">
        <div class="popup_in">
            <div class="popup">
                <div class="popup_close stay_close close-animate">
                    <a href="javascript:void(0);" @click.prevent="closePop">
                        <close />
                    </a>
                </div>
                <div class="corner-top"></div>
                <div class="exists_icon">
                    <LOGO />
                </div>
                <div class="pop_frame">
                    <h2 class="title25" style="margin-top:20px;"></h2>
                    <div class="text" style="color:#ec3b16!important" >יש לך הזמנה לתאריך {{order.meta.jckwds_date[0]}} שעברה לטיפול, והיא כבר לא זמינה לעריכה</div>
                    <div class="bt_green ease">
                        <a href="#" @click.prevent="closePopAndEdit">הבנתי אני רוצה לערוך את ההזמנה הבאה</a>
                    </div>
                    <div class="bt_green ease">
                        <a href="#" @click.prevent="closePop">טוב, אז לא משנה...</a>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import close from "../../assets/img/close.svg";
    import LOGO from "../../assets/img/carmella.svg";
    export default {
        name: "PerOrderSentNoEdit",
        props: ["order"],
        methods: {
            goToPermOrderPage() {
                this.closePop();
                this.$root.$emit('editPermOrder',{editOrder: true});
                //this.$router.push({name: 'permenent'});
            },
            goTohistory(){
                this.$router.push({path: '/my-account/history'})
              this.closePop();
            },
            closePop() {
                this.$emit('close');

            },
          closePopAndEdit(){
            this.$root.$emit('edit-order');
            this.$emit('close');
          }
        },
        components:{
            LOGO,
            close
        }
    }
</script>

<style scoped>
    .bt_green a{
        width: 100%;
    }
</style>
